import { useState } from 'react'
import { TimeSession } from '@/core/api/time-tracking'

export function useSessionDialogs() {
  const [correctSession, setCorrectSession] = useState<TimeSession | null>(null)
  const [historySessionId, setHistorySessionId] = useState<string | null>(null)
  const [createDialogOpen, setCreateDialogOpen] = useState(false)

  return {
    correctSession,
    openCorrectDialog: setCorrectSession,
    closeCorrectDialog: () => setCorrectSession(null),

    historySessionId,
    openHistoryDialog: (session: TimeSession) => setHistorySessionId(session._id),
    closeHistoryDialog: () => setHistorySessionId(null),

    createDialogOpen,
    openCreateDialog: () => setCreateDialogOpen(true),
    closeCreateDialog: () => setCreateDialogOpen(false),
  }
}
